import React from "react";
import styles from "./Contact.module.css";

function AboutMe() {
  return (
    
    <div>
      <div class="container px-5 py-24 mx-auto text-white">
        <div class="flex mb-16 md:flex-row flex-col items-center">
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
            <img
              class="object-cover object-center rounded mx-auto"
              alt="aboutcoverimage"
              src="https://avatars.githubusercontent.com/u/99539536?v=4"
            />
          </div>
          <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
            <h1 class=" tracking-wide sm:text-5xl text-3xl mb-4 font-medium">
              Hello there, <br class="hidden lg:inline-block" />
              I'm <span className="text-teal leading-relaxed">Nitin Kadam</span>
            </h1>
            <p class="mb-8 leading-relaxed mx-auto leading-relaxed text-xl text-gray-300 font-medium">
              Enthusiastic and Hardworking Full Stack Developer having the
              ability to problem-solving with specialization in MERN stack,
              having a great eye for details and always ready to learn new
              things in technology, developing interpersonal skills but having
              good team management leadership and can communicate well so
              looking for an opportunity to work in suitable position and
              technology-driven organization.
            </p>
            <a
              href="https://drive.google.com/file/d/1xKs9q5SYS-FzsanSe4zaKVEoz4h0lqmO/view?usp=sharing"
              target="_blank"
              className={styles.btndrawborder}
            >
              Resume
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
